import React from "react";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import MainButton from '../../../components/MainButton';

interface EmailLeadStat {
    [key: string]: any;
}

interface Props {
    leads: EmailLeadStat[];
    fileName: string;
}

const ExportUserCSV: React.FC<Props> = ({ leads, fileName }) => {

    const keysToRemove = [
        "rememberToken",
        "ip",
        "role",
        "salt",
        "password_hash",
        "createdAt",
        "updatedAt",
        "profile",
        "clientId"
    ];

    const keyMappings: Record<string, string> = {
        id: "Id",
        email: "Email"
    };

    const filteredLeads = leads.map((obj) =>
        Object.fromEntries(
            Object.entries(obj)
                .filter(([key]) => !keysToRemove.includes(key))
                .map(([key, value]) => [keyMappings[key] || key, value])
        )
    );

    const handleExport = (): void => {
        const csv: string = Papa.unparse(filteredLeads);

        const blob: Blob = new Blob([csv], {
            type: "text/csv;charset=utf-8;"
        });

        saveAs(blob, fileName);
    };

    return (
        <div className="flex items-center justify-center">
            <MainButton
                className="pl-3 cursor-pointer opacity-70 hover:opacity-100 flex items-center"
                onClick={handleExport}
                title="Export CSV"
            >
                <img
                    src="/images/download-icon.svg"
                    alt="Download"
                    width={20}
                    height={20}
                    className="inline-block pr-1"
                />

                <span className="text-blue-600">Export</span>

                <span className="text-blue-600 text-xs pl-1">
                    (CSV)
                </span>
            </MainButton>
        </div>
    );
};

export default ExportUserCSV;